.root {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--nexus-space-sm);
  margin-block-end: var(--nexus-space-sm);
}

.label {
  font-size: var(--nexus-text-sm);
  color: var(--nexus-text-secondary);
}

.remaining {
  font-size: var(--nexus-text-xs);
  color: var(--nexus-text-muted);
  white-space: nowrap;
}

.track {
  width: 100%;
  background: var(--nexus-secondary);
  overflow: hidden;
}

.fill {
  height: 100%;
  background: var(--nexus-text);
  transition: width var(--nexus-transition-normal) ease;
}

/* Tones. Only applied when the value carries a judgement — the default fill
   stays --nexus-text so a capacity bar never competes with the primary action
   or an org's own branding. */
.success .fill {
  background: var(--nexus-success);
}

.warning .fill {
  background: var(--nexus-warning);
}

.critical .fill {
  background: var(--nexus-danger);
}

.sm .track {
  height: 2px;
}

.md .track {
  height: 3px;
}

@media (prefers-reduced-motion: reduce) {
  .fill {
    transition: none;
  }
}
